<div class="Home">
  <header-bar></header-bar>
  <b-offcanvas v-model="state_data.sidemenu" :title="$t('menu.title')" style="width:75%;"
        header-class="bg-secondary text-light" body-class="px-0 py-0">
    <b-list-group class="mx-0 px-0">
      <b-list-group-item button @click="edit()">{{ $t('menu.edit') }}</b-list-group-item>
      <b-list-group-item button @click="retire_open()">{{ $t('menu.retire') }}</b-list-group-item>
      <b-list-group-item button @click="signout_open()">{{ $t('menu.signout') }}</b-list-group-item>
    </b-list-group>
  </b-offcanvas>
  
  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-0">
    <div class="text-center mt-4">
      <img v-if="currentLocale === 'en'" :alt="$t('header.title')" src="../../assets/battery-care-image-500x256-EN.png" class="img-fluid" />
      <img v-else :alt="$t('header.title')" src="../../assets/battery-care-image-500x256-JP.png" class="img-fluid" />
    </div>
    <div class="text-center mt-4 mx-4">
      <div class="markdown-body" v-html="bind_data.markdowntext"></div>
    </div>

    <div class="m-3 p-1">
      <a href="https://px.a8.net/svt/ejp?a8mat=4BCMO1+E22GZ6+4W9U+609HT" rel="nofollow">
      <img border="0" width="468" height="60" alt="" src="https://www26.a8.net/svt/bgt?aid=260929729850&wid=001&eno=01&mid=s00000022845001009000&mc=1"></a>
      <img border="0" width="1" height="1" src="https://www13.a8.net/0.gif?a8mat=4BCMO1+E22GZ6+4W9U+609HT" alt="">
    </div>

    <footer class="sticky-bottom">
      <b-row>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="Guide()">{{ $t('nav.Guide') }}</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="privacy_policy()">{{ $t('nav.privacy_policy') }}</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="terms_of_service()">{{ $t('nav.terms_of_service') }}</b-button>
        </b-col>
      </b-row>
      <br>
    </footer>
  </b-container>
  
</div>